export default __webpack_public_path__ + "static/B0246-c4039fa7f89e2563b2b489933245b0f9.png";